import { AutoWorksheet, AutoWorksheetRevision, VehicleEvaluationDTO, WorksheetDecision } from '@src/data/types'

import { makeCreate, makeGetListWithIdsFromApi, makeGetSingleFromApi, makeUpdate } from '../make-api'

export function transformWorksheetRevisionFromApi(revision: AutoWorksheetRevision): AutoWorksheetRevision {
  const ret = revision

  ret.vehicleAccAndFees = computeFeesAndAccessories(revision)

  return ret
}

const computeFeesAndAccessories = (worksheet: AutoWorksheet) => {
  if (worksheet)
    return (
      (worksheet.dealerAdminFee ?? 0) +
      (worksheet.lenderFee ?? 0) +
      (worksheet.icebergPPSA ?? 0) +
      (worksheet.installationDelivery ?? 0) +
      (worksheet.licenseFee ?? 0) +
      (worksheet.otherNonTaxable ?? 0) +
      (worksheet.otherTaxable ?? 0)
    )

  return 0
}

const baseUrl = '/Applications/auto/{creditApplicationId}/worksheet'
const autoWorksheetApi = {
  getById: makeGetSingleFromApi<AutoWorksheet>(baseUrl, transformWorksheetRevisionFromApi),
  create: makeCreate<AutoWorksheet>(baseUrl),
  update: makeUpdate<AutoWorksheet>(baseUrl),
  updateVehicleEvaluationDTO: makeUpdate<VehicleEvaluationDTO, AutoWorksheet>(`${baseUrl}/VehicleEvaluation`),
  updateDecision: makeUpdate<WorksheetDecision, AutoWorksheet>(`${baseUrl}/Decision`),
  getWorksheetRevisions: makeGetListWithIdsFromApi<AutoWorksheetRevision>(
    `${baseUrl}/Revisions`,
    transformWorksheetRevisionFromApi,
  ),
}

export default autoWorksheetApi
